<header>
  <div id="topheader">
    <nav class="navbar navbar-expand-xl navbar-dark btco-hover-menu fixed-top bg-white">
      <div class="container">
        <a class="navbar-brand" routerLink="">
          <img src="assets/img/logo.png" />
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse"  (click)="toggleMenu()"
          aria-haspopup="true" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse" >
          <ul class="navbar-nav navbars" *ngIf="menuToggle ||  !isDevice()" >
            <!-- <li class="nav-item">
                <a class="nav-link" routerLinkActive="active" routerLink="">Home
            </a></li> -->
            <li class="nav-item" (click)="toggleMenu()">
              <a class="nav-link" routerLinkActive="active"  routerLink="/about">About Us</a>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active"  >
              <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                Services
              </a>
              <ul class="dropdown-menu" data-aos="fade-up" data-aos-duration="0s"
                aria-labelledby="navbarDropdownMenuLink" style="left: -47%">
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLinkActive="active" routerLink="/software-development">  Software Development</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLinkActive="active" routerLink="/mobility-solutions">  Mobility Solutions</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/digital-transformation"> 
                    Digital Transformation
                  </a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/it-infra-cloud">  IT Infra &amp;
                    Cloud</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/consulting-managed-service"> 
                    Consulting &amp; Managed
                    Services</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/qa-testing">  QA &amp;
                    Testing</a>
                </li>
              </ul>
            </li>
            <li class="nav-item dropdown" routerLinkActive="active" >
              <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
                Clientele
              </a>
              <ul class="dropdown-menu animated fadeIn" data-wow-duration="0s" aria-labelledby="navbarDropdownMenuLink"
                style="left: -22%">
                <li (click)="toggleMenu()" >
                  <a class="dropdown-item" routerLink="/banking-finance">Banking &amp;
                    Finance</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/insurance"> Insurance</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/fintech">Fintech</a>
                </li>
                <li (click)="toggleMenu()">
                  <a class="dropdown-item" routerLink="/ecommerce-retail">E-Commerce
                    &amp; Retail</a>
                </li>
              </ul>
            </li>
            <li class="nav-item" (click)="toggleMenu()">
              <a class="nav-link" aria-haspopup="true" routerLinkActive="active" routerLink="/current-opening">
                Careers
              </a>
            </li>
            <li class="nav-item" (click)="toggleMenu()">
              <a class="nav-link" routerLinkActive="active" routerLink="/contact">Contact Us</a>
            </li>
          </ul>
        </div>
        <div class="social-links1">
          <ul>
            <li>
              <a href="https://www.linkedin.com/company/comunus-technolgies-pvt-ltd" target="_blank">
                <img src="assets/img/linkedin.png"  class="linkedin"/>
              </a>
            </li>
            <li class="d-lg-block d-md-block d-sm-none d-none">
              <a href="https://www.facebook.com/comunustechnologies" target="_blank"><img
                  src="assets/img/FB.png" /></a>
            </li>
            <li>
              <a href="https://www.instagram.com/comunustechnologies/?igshid=MDM4ZDc5MmU%3D" target="_blank">
                <img src="assets/img/instagram.png" />
              </a>
            </li>
             <li >
              <a href="https://www.youtube.com/channel/UCKAu4gTMgDklr3bymCXBpAQ" target="_blank">
                <img src="assets/img/youtube.png" />
              </a>
            </li>
            <li class="d-lg-block d-md-block d-sm-none d-none">
              <a href="https://twitter.com/hashtag/comunustechnologiespvtltd" target="_blank">
                <img src="assets/img/twitter.png" style="width: 63%;" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</header>
